import { mutatorAction } from "satcheljs";
import { SchedulesViewStateStore } from "sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";

/**
 * Sets the show date in header boolean
 */
export default mutatorAction("SET_SHOW_DATE_IN_HEADER",
    function setShowDateInHeader(store: SchedulesViewStateStore | IPreviewSchedulePageStore, showDateInHeader: boolean) {
        store.showDateInHeader = showDateInHeader;
    }
);